
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaonrentinpune() {



    const cardData =
    {
        keyword: 'Innova Crysta On Rent in Pune',
        heading: 'Platinum24 Cabs: Innova Crysta On Rent in Pune',
        headingDescription: ' Platinum24 Cabs offers premium Innova Crysta on Rent in Pune, ideal for family tours, corporate travel, outstation trips, and airport transfers. Known for its spacious interiors, plush seating, and superior comfort, the Innova Crysta is the perfect choice for long journeys and group travel. Our fleet is well-maintained, air-conditioned, and driven by professional chauffeurs to ensure safety and punctuality. With affordable rental packages, flexible booking options, and 24/7 availability, Platinum24 Cabs guarantees a hassle-free and comfortable travel experience every time you choose our Innova Crysta rental service in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort palace. Once the seat of the Maratha Empire, its massive gates, fountains, and ruins narrate tales of grandeur. Though destroyed by fire in 1828, it still draws thousands of visitors. The evening light-and-sound show recreates the legacy of Bajirao and Mastani. Tourists love exploring its historic courtyards and gardens. Shaniwar Wada is Pune’s proud heritage symbol."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum showcasing Gandhi’s belongings and photographs. The Italian arches and sprawling lawns add architectural beauty. It is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historical and inspirational landmark."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought bravely for Chhatrapati Shivaji Maharaj. The fort offers trekking trails, temples, and panoramic views of the Sahyadris. In monsoon, mist and waterfalls make the climb enchanting. Visitors also enjoy local delicacies like pithla-bhakri at the fort. It is a blend of adventure and history. Sinhagad is Pune’s must-visit trekking and heritage spot."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the center of grand festivities with thousands of devotees. The temple is also known for its charitable activities. It is a spiritual and cultural icon of the city. Dagdusheth Ganpati is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The temple features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city center, it offers peace and spirituality. Its architecture reflects ancient Indian craftsmanship. Evening chants create a mystical aura. Pataleshwar is Pune’s hidden spiritual gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, sculptures, musical instruments, and everyday antiques. The recreated Mastani Mahal is a highlight. It is an educational and fascinating spot for history enthusiasts. The museum preserves Indian traditions across centuries. It is Pune’s cultural treasure house."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city. At its summit stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, it also houses museums and smaller shrines. Climbing 103 steps to the top is both devotional and adventurous. Sunrise and sunset views here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global center for wellness and spirituality. Spread across lush gardens, it attracts seekers worldwide. It offers meditation, yoga sessions, and personal growth workshops. The ashram’s Zen gardens and serene meditation halls provide tranquility. It is ideal for rejuvenation and mindfulness. Osho Ashram is Pune’s international hub of peace and harmony."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns make it a peaceful retreat. Families enjoy strolls, photography, and picnics here. The garden represents Indo-Japanese cultural friendship. Seasonal flowers enhance its beauty year-round. Pu La Deshpande Garden is Pune’s green oasis of calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite weekend destination near Pune. It supplies water to the city while offering picturesque landscapes. During monsoon, the overflowing dam becomes a spectacular sight. Street food stalls selling corn and tea make it lively. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway."
  }
],



     "services": [
    {
      "name": "Innova Crysta Rental Pune",
      "description": "Experience premium travel with our Innova Crysta rental service in Pune, perfect for families, groups, and corporate clients seeking spacious and comfortable rides. Our well-maintained Innova Crysta vehicles offer advanced safety features, plush interiors, and excellent performance, making your journeys smooth and enjoyable. Whether it’s a city trip, weekend getaway, or long-distance travel, rent an Innova Crysta and travel in style."
    },
    {
      "name": "Innova Crysta On Rent Pune",
      "description": "Rent an Innova Crysta in Pune with flexible rental durations from hourly to long-term plans. Ideal for travelers looking for reliable, luxurious, and roomy vehicles with modern amenities. Our rental process is quick and transparent, offering the best rates and comprehensive support throughout your journey."
    },
    {
      "name": "Rent Innova Crysta Pune",
      "description": "Rent your Innova Crysta in Pune easily with our seamless online or phone booking options. Choose from self-drive or chauffeur-driven services with clean, sanitized cars that meet the highest safety and comfort standards. Enjoy hassle-free rentals with timely pick-up and drop-off, ensuring a stress-free experience every time."
    },
    {
      "name": "Pune Innova Crysta Car Hire",
      "description": "Professional Innova Crysta car hire service in Pune, tailored for tourists, families, and corporate travelers. Our cars are maintained regularly to ensure reliability, comfort, and performance on every trip. Benefit from personalized customer service, competitive pricing, and multiple payment options for your convenience."
    },
    {
      "name": "Innova Crysta Taxi Service Pune",
      "description": "Reliable Innova Crysta taxi service in Pune with experienced drivers familiar with all routes and local traffic patterns. Ideal for airport transfers, business travel, and sightseeing tours. Our taxi service guarantees punctuality, safety, and courteous drivers to provide a premium travel experience."
    },
    {
      "name": "Affordable Innova Crysta Rental Pune",
      "description": "Affordable Innova Crysta rental options in Pune without compromising on vehicle quality or service. Enjoy competitive rates, transparent pricing, and no hidden fees. Our rental packages include insurance, taxes, and optional extras, making it easier for you to plan your budget for short or long trips."
    },
    {
      "name": "Innova Crysta with Driver Pune",
      "description": "Hire an Innova Crysta with a professional driver in Pune for a relaxed and comfortable travel experience. Our drivers are trained, courteous, and knowledgeable about Pune’s routes, ensuring you reach your destination safely and on time. Perfect for corporate trips, family outings, or special events."
    },
    {
      "name": "Pune Innova Crysta Booking",
      "description": "Book your Innova Crysta rental in Pune through our easy-to-use online portal or customer service helpline. Get instant confirmation, flexible pickup/drop-off options, and 24/7 customer support. We strive to make your booking process seamless, offering clear terms and excellent service."
    },
    {
      "name": "Innova Crysta Car Rental Pune",
      "description": "Choose from a wide range of Innova Crysta rental cars in Pune for personal or professional use. Our vehicles are well-maintained, fully insured, and sanitized for your safety. Whether you need a self-drive option or a chauffeur-driven ride, we have packages tailored to your requirements."
    },
    {
      "name": "Innova Crysta Hire for Tours Pune",
      "description": "Plan your tours around Pune and nearby attractions with our Innova Crysta hire service. Spacious and comfortable, the Innova Crysta is perfect for group travel, sightseeing, and family vacations. Our tour packages come with options for driver assistance, flexible itinerary changes, and competitive pricing."
    },
    {
      "name": "Innova Crysta Rental for Family Trips Pune",
      "description": "Make your family trips memorable with our Innova Crysta rentals in Pune. Offering ample space for passengers and luggage, the Innova Crysta ensures comfort for every family member. Enjoy a smooth ride with safety features like airbags, ABS, and child locks, plus extras like music systems and charging ports to keep everyone entertained."
    },
    {
      "name": "Innova Crysta Airport Taxi Pune",
      "description": "Reliable Innova Crysta airport taxi service in Pune for hassle-free pickups and drop-offs. Our drivers track your flight timings to adjust schedules and minimize wait times. Enjoy a comfortable, spacious ride with plenty of luggage space, ensuring a stress-free start or end to your journey."
    },
    {
      "name": "Innova Crysta Corporate Cab Pune",
      "description": "Professional Innova Crysta corporate cab service in Pune tailored to meet business travel needs. Punctual, comfortable, and equipped with modern amenities, our corporate cabs ensure your employees or clients travel in style and safety. Flexible billing and monthly packages available for seamless corporate expense management."
    },
    {
      "name": "Innova Crysta Rental Deals Pune",
      "description": "Explore special Innova Crysta rental deals in Pune including weekend discounts, long-term rental offers, and festive season promotions. Our deals are designed to offer maximum value, helping you enjoy premium rides at affordable prices. Stay updated with our latest offers to get the best rental experience."
    },
    {
      "name": "Pune Innova Crysta Car Rental Packages",
      "description": "Customized car rental packages for Innova Crysta in Pune to suit diverse travel needs like local commuting, long tours, corporate events, or airport transfers. Packages include options for self-drive, chauffeur services, additional driver allowance, and comprehensive insurance, ensuring you get a complete and worry-free rental experience."
    }
  ],
  "tableData": [
    ["Innova Crysta Rental Pune", "Innova Crysta On Rent Pune"],
    ["Rent Innova Crysta Pune", "Pune Innova Crysta Car Hire"],
    ["Innova Crysta Taxi Service Pune", "Affordable Innova Crysta Rental Pune"],
    ["Innova Crysta with Driver Pune", "Pune Innova Crysta Booking"],
    ["Innova Crysta Car Rental Pune", "Innova Crysta Hire for Tours Pune"],
    ["Innova Crysta Rental for Family Trips Pune", "Innova Crysta Airport Taxi Pune"],
    ["Innova Crysta Corporate Cab Pune", "Innova Crysta Rental Deals Pune"],
    ["Pune Innova Crysta Car Rental Packages", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Innova Crysta on Rent in Pune for Premium Travel",
      "WhyChoosedescription": "Platinum24 Cabs offers top-quality Innova Crysta rentals in Pune, perfect for luxurious and comfortable journeys."
    },
    {
      "WhyChooseheading": "Spacious 6 & 7-Seater Options for Family and Business Trips",
      "WhyChoosedescription": "Choose from flexible seating options to suit your group’s size, whether for leisure or corporate travel."
    },
    {
      "WhyChooseheading": "Perfect for Outstation Trips, Airport Transfers, and City Travel",
      "WhyChoosedescription": "Enjoy a smooth and stylish ride for long drives, airport pickups, or everyday travel in Pune."
    },
    {
      "WhyChooseheading": "Fully Air-Conditioned with Pushback Seats and Ample Luggage Space",
      "WhyChoosedescription": "Travel in comfort with plush interiors, reclining seats, and enough space for all your bags."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Chauffeurs",
      "WhyChoosedescription": "Our professional drivers ensure your safety and punctuality while offering a pleasant travel experience."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
      "WhyChoosedescription": "Every Innova Crysta is regularly cleaned and maintained to ensure hygiene and performance."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Get upfront quotes that include fuel, tolls, and driver allowances—no surprises later."
    },
    {
      "WhyChooseheading": "Easy Booking for Hourly, Daily, or Outstation Use",
      "WhyChoosedescription": "Book your Innova Crysta rental as per your schedule—hourly, full-day, or for multiple days."
    }
  ]




















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Innova Crysta on rent in Pune?',
        answer: 'Yes, Platinum24 Cabs provides Innova Crysta rentals in Pune for comfortable and spacious travel.',
    },
    {
        question: 'How can I book an Innova Crysta on rent in Pune with Platinum24 Cabs?',
        answer: 'You can book an Innova Crysta easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What is the seating capacity of the Innova Crysta available for rent?',
        answer: 'The Innova Crysta typically seats 7 passengers comfortably, ideal for family and group travel.',
    },
    {
        question: 'Are the Innova Crysta vehicles well-maintained and clean?',
        answer: 'Yes, all Innova Crysta cars are regularly serviced, cleaned, and sanitized for a safe and pleasant journey.',
    },
    {
        question: 'Can I hire an Innova Crysta for local Pune travel as well as outstation trips?',
        answer: 'Absolutely! We offer rentals for both local travel within Pune and outstation trips to nearby destinations.',
    },
    {
        question: 'What rental packages are available for Innova Crysta in Pune?',
        answer: 'We offer flexible hourly, daily, and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Do Innova Crysta rentals come with a driver?',
        answer: 'Yes, all rentals include professional, experienced drivers to ensure a safe and hassle-free trip.',
    },
    {
        question: 'Can I customize pickup and drop-off locations when renting an Innova Crysta?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points for a convenient travel experience.',
    },
    {
        question: 'What safety measures are followed for Innova Crysta rentals?',
        answer: 'Our vehicles are regularly sanitized, and drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is corporate Innova Crysta rental available in Pune?',
        answer: 'Yes, we provide customized corporate rental solutions for Innova Crysta with priority support and flexible billing options.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Karan Joshi',
        feedback: 'Renting an Innova Crysta from Platinum24 Cabs in Pune was a fantastic experience. The vehicle was spacious and the driver punctual.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Ananya Desai',
        feedback: 'The Innova Crysta rental service was excellent. Clean car, smooth ride, and great customer service.',
        rating: 5,
    },
];


































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const innovaCrystaOnRentPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta On Rent in Pune",
  "image": "https://www.platinum24cab.com/assets/images/innova-crysta-pune.jpg",
  "description": "Rent Innova Crysta in Pune for family trips, corporate travel, airport transfers, and tours. Affordable rates with driver and luxury options at Platinum24 Cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/innova-crysta-on-rent-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>Innova Crysta On Rent in Pune | Family & Corporate Rental | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Rent Innova Crysta in Pune for family trips, corporate travel, airport transfers, and tours. Affordable rates with driver and luxury options at Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="Innova Crysta Rental Pune, Innova Crysta On Rent Pune, Rent Innova Crysta Pune, Pune Innova Crysta Car Hire, Innova Crysta Taxi Service Pune, Affordable Innova Crysta Rental Pune, Innova Crysta with Driver Pune, Pune Innova Crysta Booking, Innova Crysta Car Rental Pune, Innova Crysta Hire for Tours Pune, Innova Crysta Rental for Family Trips Pune, Innova Crysta Airport Taxi Pune, Innova Crysta Corporate Cab Pune, Innova Crysta Rental Deals Pune, Pune Innova Crysta Car Rental Packages"
  />
  <script type="application/ld+json">
    {JSON.stringify(innovaCrystaOnRentPuneSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacrystaonrentinpune;